export class Breed {
  fg: string | null = null;
  bg: string | null = null;
  ch: string | null = null;
  name = "";
  info = "";
  description = "";
  logName = "";
  displayPriority = 1;

  constructor(public key: string, breedData: any) {
    Object.assign(this, breedData.glyph, breedData.text);
    this.displayPriority = breedData.displayPriority || 1;
  }
}
